module.exports = __webpack_public_path__ + "static/media/collage3_480.24858143.png";